import { NoDataEnDash } from '@packages/components/no-data-en-dash/no-data-en-dash';

import { CVELinksWithDrawer } from '../cve-links-with-drawer/cve-links-with-drawer';
import type { RiskManagementRow } from '../risks-management-table/risk-management-table';

type Props = { row: RiskManagementRow };

export const CVECell = ({ row }: Props) => {
  if (row.cve?.primary?.id) {
    return <CVELinksWithDrawer item={row} />;
  }
  return <NoDataEnDash />;
};
